var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.vouchers) ? _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.vouchers), function(m, index) {
    return [_c('tr', {
      staticClass: "row m-0"
    }, [_c('td', {
      staticClass: "align-middle col-md-5"
    }, [_vm._v("\n                      " + _vm._s(m.medicine ? m.medicine.label : '') + "\n                      " + _vm._s(m.individual_medicine ? m.individual_medicine.name : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.disease !== null ? m.disease.code : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(_vm._f("boolToCS")(m.paid_by_sick)) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.amount) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.dosage) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "text-left col-md-2"
    }, [_vm._v("\n                        " + _vm._s(m.created_at) + "\n                      "), (m.prescription) ? [(m.prescription.patient_notification_type === 'SMS') ? _c('i', {
      staticClass: "fa fa-mobile-phone",
      attrs: {
        "title": "Recept odeslán přes SMS",
        "aria-hidden": "true"
      }
    }) : (m.prescription.patient_notification_type === 'EMAIL') ? _c('i', {
      staticClass: "fa fa-envelope-o",
      attrs: {
        "title": "Recept odeslán přes e-mail",
        "aria-hidden": "true"
      }
    }) : _c('i', {
      staticClass: "fa fa-ban text-danger",
      attrs: {
        "title": "Bez notifikace o receptu",
        "aria-hidden": "true"
      }
    })] : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "col-md-1 row justify-content-start m-0"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary btn_line-heigh-1",
      attrs: {
        "title": "kopírovat"
      },
      on: {
        "click": function($event) {
          _vm.copyVoucher(m)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clone",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]
  })], 2)])]) : (_vm.vouchersPending) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n        (načítám)\n    ")]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-md-5"
  }, [_vm._v("Lék")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Diagnóza")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Hradí pacient")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Počet bal.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Dávkování")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("Předepsáno")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7370797e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/components/ListPreviousVoucher.vue
// module id = 587
// module chunks = 0